import * as React from 'react';

import * as styles from './AsideCianContacts.css';
import { Label } from '@cian/ui-kit';

export const AsideCianContacts: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['label']} data-testid="AsideCianContactsLabel">
        <Label background="surface-positive-default" color="accent-positive-primary">
          КОНСУЛЬТАНТ
        </Label>
      </div>
      <div className={styles['info']}>
        <strong className={styles['title']}>Циан</strong>
        <p className={styles['description']}>Основан в 2001 году</p>
      </div>
      <div className={styles['buttons']}>{children}</div>
    </div>
  );
};

AsideCianContacts.displayName = 'AsideCianContacts';
